import AOS from 'aos';
export default {
  init() {
    // JavaScript to be fired on all pages

    AOS.init({
      once: true,
    })
    $(window).on('scroll', function() {
      if($(window).scrollTop() > 200) {
        $('.header').addClass('header-scroll')
      } else {
        $('.header').removeClass('header-scroll')
      }
    })

    $(window).on('load', function () {
      if($(window).width() <= 768) {
        $('.carousel-items').addClass('owl-carousel').owlCarousel({
          items: 1,
          stagePadding: 40,
          margin: 20,
          dots: true,
        })
      } else {
        $('.our-mission-item').each(function() {
          let item = $(this)
          item.mouseover(function () {
            $('.our-mission-item').removeClass('active')
            $(this).addClass('active')
          })
        })
      }
    })
    
    $('img.svg').each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');
      $.get(imgURL, function (data) {
        var $svg = jQuery(data).find('svg');
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        $svg = $svg.removeAttr('xmlns:a');
        $img.replaceWith($svg);
      }, 'xml');
    });

    $('.menu-button').click(function() {
      $(this).toggleClass('change')
      $('.header').toggleClass('active')
    })

    let $overlay = $('.overlay')
    let $modal = $('.modal-form')

    $overlay.click(function() {
      closeModal()
    })
    
    $('.show-request').click(function (e) {
      e.preventDefault()
      showModal()
    })
    $('.close-modal').click(function () {
      closeModal()
    })

    function showModal() {
      $overlay.addClass('active')
      $modal.addClass('active')
    }

    function closeModal() {
      $overlay.removeClass('active')
      $modal.removeClass('active')
    }

    // cookies 
    if(getCookie('accepted-cookies')){
      $('.cookie-box').hide()
    } else {
      $('.cookie-box').show()
    }

    $('.close-cookie-box').click(function() {
      $('.cookie-box').hide()
    })

    $('.agree-btn').click(function(){
      $('.cookie-box').hide();
      setCookie('accepted-cookies', true, 60)
    })

    /* eslint-disable */
    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js